export const SET_USERS = 'users/set-users';
export const SET_SELECTED_USER = 'users/set-selected-user';
export const SET_SELECTED_USER_AUTHORITIES = 'users/set-selected-user-authorities';
export const TOGGLE_LOADING = 'users/set-toggle-loading';
export const SET_USERS_TOTAL = 'users/set-users-total';
